import { useEffect, useState } from 'react';
import api from '../lib/api';

export function OrgUsageBanner() {
  const [readonly, setReadonly] = useState(false);
  const [periodEnd, setPeriodEnd] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get('/orgs/me')
      .then((r) => {
        if (cancelled) return;
        const ps = r.data?.usage?.practiceSessions;
        setReadonly(Boolean(ps?.readonly));
        setPeriodEnd(typeof ps?.periodEnd === 'string' ? ps.periodEnd : null);
      })
      .catch(() => {
        if (!cancelled) {
          setReadonly(false);
          setPeriodEnd(null);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!readonly || !periodEnd) return null;

  const resetLabel = new Date(periodEnd).toLocaleDateString(undefined, {
    dateStyle: 'medium',
    timeZone: 'UTC',
  });

  return (
    <div className="bg-amber-50 border-b border-amber-200 text-amber-950 px-4 py-2 text-sm text-center">
      This organization has reached its practice session limit for this month. You can continue open
      sessions; creating new sessions or other changes resume after{' '}
      <span className="font-medium">{resetLabel}</span> (UTC month).
    </div>
  );
}
